import React from "react";
import '../App.css';
import '../style/style.css';
import '../style/sb-admin-2.min.css';
import '../style/perfect-scrollbar.css';
import '../font/css/all.min.css';
import logo from '../img/logo.png';


const MentorSidebar =(props) => {

    return(
        <div id="wrapper">

        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
        <a className="sidebar-brand d-flex align-items-center justify-content-center" href="">
           <div className="sidebar-brand-icon">
              <img src={logo} className="img-fluid"/>
           </div>
        </a>
        

        <li className={`nav-item ${props.casemanagement}`}>
           <a className="nav-link" href="mentorcase">
           <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
                 <title>menu</title>
                 <desc>Created with Sketch.</desc>
                 <g id="🎨-[Setup]:-Colors" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Mentor" transform="translate(-22.000000, -186.000000)" fill="#FFFFFF">
                       <g id="sidebar">
                          <g id="menu" transform="translate(22.000000, 186.102041)">
                             <ellipse id="Oval" cx="2.5" cy="2.39795918" rx="2.5" ry="2.39795918"/>
                             <ellipse id="Oval-Copy-2" cx="2.5" cy="11.0306122" rx="2.5" ry="2.39795918"/>
                             <ellipse id="Oval-Copy" cx="11.5" cy="2.39795918" rx="2.5" ry="2.39795918"/>
                             <ellipse id="Oval-Copy-3" cx="11.5" cy="11.0306122" rx="2.5" ry="2.39795918"/>
                          </g>
                       </g>
                    </g>
                 </g>
              </svg>
              <span className="navs">Case Management </span>
           </a>
        </li>

       
     </ul>
        </div>
    )

};

export default MentorSidebar;